module.exports = __webpack_public_path__ + "static/media/RhythmPlanet.99e8bbb.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/RhythmPlanet/top/RhythmPlanet.mp4
// module id = Ixb/
// module chunks = 0